import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  Button,
  Dropdown
} from 'semantic-ui-react'

const CardClinicAnnualReportUX = (props: any) => {
    return(
      <div
        id="CardClinicAnnualReportUX-div-0"
        style={{position: "relative", padding: "1em"}}>
        <div
          id="CardClinicAnnualReportUX-div-1"
          style={{display: "flex", alignItems: "center"}}>
          
          <label
            id="CardClinicAnnualReportUX-label-2"
            style={{fontWeight: "bold", fontSize: "large", marginRight: "2rem"}}>
            {props.languageUX === "en" ? "Clinic Report" : "รายงานประจำคลินิก"}
          </label>
          <Dropdown
            className="size small"
            id="CardClinicAnnualReportUX-Dropdown-24"
            onChange={props.onChangeDivision}
            options={props.divisionOptions}
            placeholder="Please select the division"
            search={true}
            selectOnBlur={true}
            selection={true}
            style={{marginRight: "0.5rem"}}
            value={props.selectedDivisionId??""}>
          </Dropdown>
        </div>
        <hr
          id="CardClinicAnnualReportUX-hr-21">
        </hr>
        <div
          id="CardClinicAnnualReportUX-div-20"
          style={{display: "flex"}}>
          
          <Form
            id="CardClinicAnnualReportUX-Form-4">
            <FormGroup
              className="ui form"
              id="CardClinicAnnualReportUX-FormGroup-6"
              style={{padding: "1em 0em 1em 1em", gap: "5em"}}>
              <Button
                disabled={!props.selectedDivisionId}
                id="CardClinicAnnualReportUX-Button-23"
                onClick={() => props.onHandleSelectedMenu("รายงานค่าตอบแทนแพทย์ตามวันที่รับชำระ")}
                style={{width: "25em"}}>
                {props.languageUX === "en" ? "Physician compensation report by payment date" : "รายงานค่าตอบแทนแพทย์ตามวันที่รับชำระ"}
              </Button>
              <Button
                disabled={!props.selectedDivisionId}
                id="CardClinicAnnualReportUX-Button-12"
                onClick={() => props.onHandleSelectedMenu("รายงานสรุปค่าใช้จ่ายผู้ป่วยเข้ารับบริการที่คลินิก")}
                style={{width: "25em"}}>
                รายงานสรุปค่าใช้จ่ายผู้ป่วยเข้ารับบริการที่คลินิก
              </Button>
            </FormGroup>
            <FormGroup
              className="ui form"
              id="CardClinicAnnualReportUX-FormGroup-7"
              style={{padding: "1em 0em 1em 1em", gap: "5em"}}>
              <Button
                disabled={!props.selectedDivisionId}
                id="CardClinicAnnualReportUX-Button-11"
                onClick={() => props.onHandleSelectedMenu("รายงานสรุปรายได้ และค่าตอบแทนแพทย์")}
                style={{width: "25em"}}>
                {props.languageUX === "en" ? "Summary report of income and physician compensation" : "รายงานสรุปรายได้ และค่าตอบแทนแพทย์"}
              </Button>
              <Button
                disabled={!props.selectedDivisionId}
                id="CardClinicAnnualReportUX-Button-14"
                onClick={() => props.onHandleSelectedMenu("รายงานผู้ป่วยค้างชำระ")}
                style={{width: "25em"}}>
                {props.languageUX === "en" ? "Overdue patient report" : "รายงานผู้ป่วยค้างชำระ"}
              </Button>
            </FormGroup>
            <FormGroup
              className="ui form"
              id="CardClinicAnnualReportUX-FormGroup-8"
              style={{padding: "1em 0em 1em 1em", gap: "5em"}}>
              <Button
                disabled={!props.selectedDivisionId}
                id="CardClinicAnnualReportUX-Button-13"
                onClick={() => props.onHandleSelectedMenu("รายงานสรุปรายได้ทั้งเดือนส่งเบิกจ่ายแพทย์")}
                style={{width: "25em"}}>
                {props.languageUX === "en" ? "Monthly income summary report submitted for medical reimbursement" : "รายงานสรุปรายได้ทั้งเดือนส่งเบิกจ่ายแพทย์"}
              </Button>
              <Button
                disabled={!props.selectedDivisionId}
                id="CardClinicAnnualReportUX-Button-16"
                onClick={() => props.onHandleSelectedMenu("รายงานผู้ป่วยที่ยังไม่ได้บันทึกรับชำระ")}
                style={{width: "25em"}}>
                {props.languageUX === "en" ? "Report on patients whose payments have not been recorded" : "รายงานผู้ป่วยที่ยังไม่ได้บันทึกรับชำระ"}
              </Button>
            </FormGroup>
            <FormGroup
              className="ui form"
              id="CardClinicAnnualReportUX-FormGroup-9"
              style={{padding: "1em 0em 1em 1em", gap: "5em"}}>
              <Button
                disabled={!props.selectedDivisionId}
                id="CardClinicAnnualReportUX-Button-15"
                onClick={() => props.onHandleSelectedMenu("รายงานการแบ่งจ่ายค่าตอบแทนตามประเภทงาน")}
                style={{width: "25em"}}>
                {props.languageUX === "en" ? "Report on compensation distribution by job type" : "รายงานการแบ่งจ่ายค่าตอบแทนตามประเภทงาน"}
              </Button>
              <Button
                disabled={!props.selectedDivisionId}
                id="CardClinicAnnualReportUX-Button-18"
                onClick={() => props.onHandleSelectedMenu("รายงานผู้ป่วยที่ชำระค่าบริการ")}
                style={{width: "25em"}}>
                {props.languageUX === "en" ? "Report on patients who have paid for services" : "รายงานผู้ป่วยที่ชำระค่าบริการ"}
              </Button>
            </FormGroup>
            <FormGroup
              className="ui form"
              id="CardClinicAnnualReportUX-FormGroup-10"
              style={{padding: "1em 0em 1em 1em", gap: "5em"}}>
              <Button
                disabled={!props.selectedDivisionId}
                id="CardClinicAnnualReportUX-Button-17"
                onClick={() => props.onHandleSelectedMenu("รายงานค่ารักษาที่แพทย์เปลี่ยนแปลงราคา")}
                style={{width: "25em"}}>
                {props.languageUX === "en" ? "Report on treatment costs where the doctor has changed the price" : "รายงานค่ารักษาที่แพทย์เปลี่ยนแปลงราคา"}
              </Button>
              <Button
                disabled={!props.selectedDivisionId}
                id="CardClinicAnnualReportUX-Button-25"
                onClick={() => props.onHandleSelectedMenu("รายงานสรุปรายได้คลินิก")}
                style={{width: "25em"}}>
                {props.languageUX === "en" ? "Clinic Income Summary Report" : "รายงานสรุปรายได้คลินิก"}
              </Button>
            </FormGroup>
            <FormGroup
              className="ui form"
              id="CardClinicAnnualReportUX-FormGroup-22"
              style={{padding: "1em 0em 1em 1em", gap: "5em"}}>
              <Button
                disabled={!props.selectedDivisionId}
                id="CardClinicAnnualReportUX-Button-19"
                onClick={() => props.onHandleSelectedMenu("รายงานภาพรวมการเปลี่ยนแปลงราคาโดยแพทย์")}
                style={{width: "25em"}}>
                {props.languageUX === "en" ? "Physician-Based Price Change Overview Report" : "รายงานภาพรวมการเปลี่ยนแปลงราคาโดยแพทย์"}
              </Button>
            </FormGroup>
          </Form>
        </div>
      </div>
    )
}


export default CardClinicAnnualReportUX

export const screenPropsDefault = {}

/* Date Time : Mon Sep 08 2025 12:59:54 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\", padding: \"1em\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "รายงานประจำคลินิก",
          "valueEN": "Clinic Report"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-label-2"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"large\", marginRight: \"2rem\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "Form",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-Form-4"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-FormGroup-6"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"1em 0em 1em 1em\", gap: \"5em\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormGroup",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-FormGroup-7"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"1em 0em 1em 1em\", gap: \"5em\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormGroup",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-FormGroup-8"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"1em 0em 1em 1em\", gap: \"5em\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormGroup",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-FormGroup-9"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"1em 0em 1em 1em\", gap: \"5em\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormGroup",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-FormGroup-10"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"1em 0em 1em 1em\", gap: \"5em\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Button",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "รายงานสรุปรายได้ และค่าตอบแทนแพทย์",
          "valueEN": "Summary report of income and physician compensation"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-Button-11"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleSelectedMenu(\"รายงานสรุปรายได้ และค่าตอบแทนแพทย์\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"25em\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "Button",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "รายงานสรุปค่าใช้จ่ายผู้ป่วยเข้ารับบริการที่คลินิก"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-Button-12"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleSelectedMenu(\"รายงานสรุปค่าใช้จ่ายผู้ป่วยเข้ารับบริการที่คลินิก\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"25em\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Button",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "รายงานสรุปรายได้ทั้งเดือนส่งเบิกจ่ายแพทย์",
          "valueEN": "Monthly income summary report submitted for medical reimbursement"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-Button-13"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleSelectedMenu(\"รายงานสรุปรายได้ทั้งเดือนส่งเบิกจ่ายแพทย์\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"25em\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Button",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "รายงานผู้ป่วยค้างชำระ",
          "valueEN": "Overdue patient report"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-Button-14"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleSelectedMenu(\"รายงานผู้ป่วยค้างชำระ\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"25em\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "รายงานการแบ่งจ่ายค่าตอบแทนตามประเภทงาน",
          "valueEN": "Report on compensation distribution by job type"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-Button-15"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleSelectedMenu(\"รายงานการแบ่งจ่ายค่าตอบแทนตามประเภทงาน\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"25em\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "Button",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "รายงานผู้ป่วยที่ยังไม่ได้บันทึกรับชำระ",
          "valueEN": "Report on patients whose payments have not been recorded"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-Button-16"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleSelectedMenu(\"รายงานผู้ป่วยที่ยังไม่ได้บันทึกรับชำระ\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"25em\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Button",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "รายงานค่ารักษาที่แพทย์เปลี่ยนแปลงราคา",
          "valueEN": "Report on treatment costs where the doctor has changed the price"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-Button-17"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleSelectedMenu(\"รายงานค่ารักษาที่แพทย์เปลี่ยนแปลงราคา\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"25em\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "รายงานผู้ป่วยที่ชำระค่าบริการ",
          "valueEN": "Report on patients who have paid for services"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-Button-18"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleSelectedMenu(\"รายงานผู้ป่วยที่ชำระค่าบริการ\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"25em\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "Button",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "รายงานภาพรวมการเปลี่ยนแปลงราคาโดยแพทย์",
          "valueEN": "Physician-Based Price Change Overview Report"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-Button-19"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleSelectedMenu(\"รายงานภาพรวมการเปลี่ยนแปลงราคาโดยแพทย์\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"25em\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "hr",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-hr-21"
        }
      },
      "seq": 20,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormGroup",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-FormGroup-22"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"1em 0em 1em 1em\", gap: \"5em\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Button",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "รายงานค่าตอบแทนแพทย์ตามวันที่รับชำระ",
          "valueEN": "Physician compensation report by payment date"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-Button-23"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleSelectedMenu(\"รายงานค่าตอบแทนแพทย์ตามวันที่รับชำระ\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"25em\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Dropdown",
      "parent": 1,
      "props": {
        "className": {
          "type": "value",
          "value": "size small"
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-Dropdown-24"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDivision"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "placeholder": {
          "type": "value",
          "value": "Please select the division"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selectOnBlur": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDivisionId??\"\""
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Button",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "รายงานสรุปรายได้คลินิก",
          "valueEN": "Clinic Income Summary Report"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "id": {
          "type": "value",
          "value": "CardClinicAnnualReportUX-Button-25"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleSelectedMenu(\"รายงานสรุปรายได้คลินิก\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"25em\"}"
        }
      },
      "seq": 25,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardClinicAnnualReportUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
